import { React, ts } from '_core';

import Chart from './chart';

type LinearAlphaSignalWeightsVsTimeProps = {
  id: string;
  readOnly: boolean;
  widgetKey: string;
  fullScreen?: boolean;
  loadWidgetData: (_payload: ts.types.widgets.WidgetGetDataParams) => Promise<ts.types.widgets.WidgetGetDataResponse>;
  context?: ts.types.signal.SignalAnalysisContext;
  widgetPaths: Record<'linear_alpha_model_data', string>;
  title: string;
};

const LinearAlphaSignalWeightsVsTime = ({
  id,
  readOnly,
  widgetKey,
  loadWidgetData,
  widgetPaths,
  context,
  fullScreen,
  title,
}: LinearAlphaSignalWeightsVsTimeProps) => {
  return (
    <Chart
      id={id}
      readOnly={readOnly}
      widgetKey={widgetKey}
      loadWidgetData={loadWidgetData}
      file={widgetPaths['linear_alpha_model_data']}
      definition={(context.definition as ts.types.signal.AlphaDefinition)?.json_definition as ts.types.signal.Lasso}
      fullScreen={fullScreen}
      title={title}
    />
  );
};

export default LinearAlphaSignalWeightsVsTime;
